
export const styles = theme => ({
  background: {
    backgroundImage: "url('background.jpg')",
    backgroundSize: "cover",
    width: "100%",
    height: "180vh",
    position: "fixed",
    zIndex: "-2",
    //filter: "blur(2px)"
  },
  screen: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    width: "100%",
  },
});


export const backAnim = ({viewHeight}) => ([
  {
    start: 0,
    end: viewHeight * 7,
    properties: [
      {
        startValue: 0,
        endValue: viewHeight * -1,
        property: "translateY",
      },
    ],
  },
]);